import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './components/UI/Toast';
import { AuthProvider } from './context/AuthContext';
import { RequestsProvider } from './context/RequestsContext';
import { NotificationsProvider } from './context/NotificationsContext';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import RegistrationPage from './pages/RegistrationPage';
import TrackingPage from './pages/TrackingPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import ClientsPage from './pages/ClientsPage';
import ClientProfilePage from './pages/ClientProfilePage';
import RequestsPage from './pages/RequestsPage';
import CalendarPage from './pages/CalendarPage';
import TeamManagementPage from './pages/TeamManagementPage';
import { TeamProvider } from './context/TeamContext';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          <RequestsProvider>
            <NotificationsProvider>
              <TeamProvider>
                <Router>
                  <Layout>
                  <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/register" element={<RegistrationPage />} />
                  <Route path="/track" element={<TrackingPage />} />
                  <Route path="/auth/callback" element={<AuthCallbackPage />} />
                  <Route path="/dashboard" element={
                    <ProtectedRoute>
                      <DashboardPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/profile" element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  } />
                  <Route path="/clients" element={
                    <ProtectedRoute>
                      <ClientsPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/clients/:clientId" element={
                    <ProtectedRoute>
                      <ClientProfilePage />
                    </ProtectedRoute>
                  } />
                  <Route path="/requests" element={
                    <ProtectedRoute>
                      <RequestsPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/calendar" element={
                    <ProtectedRoute>
                      <CalendarPage />
                    </ProtectedRoute>
                  } />
                  <Route path="/teams" element={
                    <ProtectedRoute>
                      <TeamManagementPage />
                    </ProtectedRoute>
                  } />
                  </Routes>
                  </Layout>
                </Router>
              </TeamProvider>
            </NotificationsProvider>
          </RequestsProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
